import axiosInstance from '../utilities/axiosInstance';

const authAPI = {
  // Check session status
  checkSession: async () => {
    try {
      const response = await fetch('/api/auth/session', {
        credentials: 'include'
      });
      return await response.json();
    } catch (error) {
      return { 
        success: false, 
        authenticated: false,
        error: `Session check failed: ${error.message}` 
      };
    }
  },

  // Logout
  logout: async () => {
    try {
      const response = await fetch('/api/auth/logout', {
        method: 'POST',
        credentials: 'include'
      });
      return await response.json();
    } catch (error) {
      return { 
        success: false, 
        error: `Logout failed: ${error.message}` 
      };
    }
  },

  // Initiate Google login (redirect)
  initiateGoogleLogin: () => {
    window.location.href = '/api/auth/google';
  },

  // Initiate Microsoft login (redirect)
  initiateMicrosoftLogin: () => {
    window.location.href = '/api/auth/microsoft';
  },

  // Initiate GitHub login (redirect)
  initiateGitHubLogin: () => {
    window.location.href = '/api/auth/github';
  },

  // ============================================================================
  // TWO-FACTOR AUTHENTICATION
  // ============================================================================

  // Generate 2FA secret and QR code
  generate2FASecret: async () => {
    try {
      const response = await axiosInstance.post('/api/auth/generate2FA');
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: `Failed to generate 2FA secret: ${error.response?.data?.error || error.message}`
      };
    }
  },

  // Enable 2FA
  enable2FA: async (secret, token) => {
    try {
      const response = await axiosInstance.post('/api/auth/enable2FA', {
        secret,
        token
      });
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: `Failed to enable 2FA: ${error.response?.data?.error || error.message}`
      };
    }
  },

  // Verify 2FA token
  verify2FA: async (token) => {
    try {
      const response = await axiosInstance.post('/api/auth/verify2FA', {
        token
      });
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: `Failed to verify token: ${error.response?.data?.error || error.message}`
      };
    }
  },

  // Disable 2FA
  disable2FA: async () => {
    try {
      const response = await axiosInstance.post('/api/auth/disable2FA');
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: `Failed to disable 2FA: ${error.response?.data?.error || error.message}`
      };
    }
  },

  // Check 2FA status
  check2FAStatus: async () => {
    try {
      const response = await axiosInstance.get('/api/auth/status2FA');
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: `Failed to check 2FA status: ${error.response?.data?.error || error.message}`
      };
    }
  }
};

export default authAPI;